import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { HttpParams } from '@angular/common/http';
import { Allergy } from '../../../@core/interfaces/masters/allergy';
import { Examination } from '../../../@core/interfaces/masters/examination';
import { PatientScoreTransDto, ScoreConfigMst } from './scoreconfigmst';

export interface ClinicalAssessmentParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}



export interface ClinicalAssessment{
   templateName:string,
   createdDate:Date,
   createdBy:number,
   createdIP:string,
   tenantId:string, 
   branchId:string,
   clinicalAssesmentSetupDet:Array<clinicalAssesmentDetail>
}

export interface clinicalAssesmentDetail{
    id?:string,
    clinicalAssessmentTransMstId?:number,
    clinicalAssesmentMstId?:string,
   rowId:number, 
   reportHeader:string, 
   pageHeader:string, 
   mainHeader:string,
   subHeaderTitle:string, 
   subHeaderRowNo:number, 
   subHeaderControlType:string, 
   subHeaderControlText:string, 
   subHeaderControlMapTable:string, 
   subHeaderControlMapFieldId:string, 
   subHeaderDefaultValue:string, 
   parentId:number,
   childId:number,
   subHeaderWaterMarkText:string, 
   subHeaderDataSource:string,
   flexDirection:string,
   subHeaderOptionValue:string, 
   subHeaderControlValue?:string,
   subHeaderMandatoryField:string,
   refTableName:string
}

export interface assessmentPatientTransaction{
        templateId:number,
        admissionId:number,
        regId:string,
        tenantId:string,
        branchId:string,
        createdBy:number,
        createdDate:Date,
        createdIP:string,
        updatedBy:string,
        updatedDate:Date,
        updatedIP: string,
        medicalHistoriesData:medicalHistoriesData
       
}
export interface medicalHistoriesData {  
        commonMaster:{
        visitId:number,
        doctorId:string
        },
        examinationMst:Array<{examinationId:string,attributeValue:string}>,
        allergyMst:Array<{allergyId:string,attributeValue:string}>
        instructionMst:Array<{id:string,attributeValue:string}>,
        diagnosisMst:Array<{id:string,attributeValue:string}>,
        complaintsMst:Array<{id:string,attributeValue:string}>,
        medicineMst:Array<{id:string,attributeValue:string}>
        COMA:PatientScoreTransDto,
        FLACC:PatientScoreTransDto,
        APGAR:PatientScoreTransDto[],
        vitalMst:assessmentvitalMst
}


export interface assessmentTransactionDetail{
        id:number,
        clinicalAssessmentMstId:number,
        clinicalAssessmentTemplateName:string, 
        regId:string, 
        admId:number,
        displayOption:string, 
        visitId:number 
        tenantId:string, 
        branchId:string, 
        createdDate:Date, 
        createdBy:number, 
        createdIP:string, 
        updatedDate:Date, 
        updatedBy:number, 
        updatedIP:string, 
        templateId:number,
        clinicalAssessmentTransDet:Array<clinicalAssesmentDetail>     
}

export interface allAssessmentMaster {
         allergyData:Allergy[],
         examinationData:Examination[],
         chiefComplaintData:Array<any>,
         instructionData:Array<any>,
         medicalHistoryData:Array<any>,
         medicineData:Array<any>,
         socialHabitsData:Array<any>,
         treatmentPlanData:Array<any>
         scoreData:Array<ScoreConfigMst>
}

export interface assessmentvitalMst{
          id:string 
          weight:number, 
          height:number, 
          bP_Sys:number, 
          bP_Dia:number, 
          spo2:number, 
          pulse:number, 
          temp:number, 
          heart_Rate:number, 
          resp_Rate:number, 
          random_Sugar:number, 
          pre_Sugar:number, 
          post_Sugar:number, 
          mothersPA:string, 
          painScore:string,
          mAPScore:string,
          nEWSScore:string,
          mothersTVS:string, 
          mothersPV:string, 
          mothersUrine:string, 
          mothersLiquorVolume:string, 
          tenantId:string, 
          branchId:string, 
          regId:string, 
          visitId:number, 
          head_circumference:number, 
          admissionId:number, 
          createdDate:Date, 
          updatedDate:Date, 
          createdBy:number, 
          updatedBy:number, 
          createdIP:string, 
          updatedIP:string,
          criticalFlag:string, 
          dataCapturedFrom:string,
          dataCapturedMethod:string, 
          dataCapturedByWhom:string, 
          deviceId:string, 
          gestationAge:string, 
          birthWeight:string, 
          birthTime:string, 
          entryFrom:string, 
          templateId:number, 
}

export interface imageDetail{
                   id?:string
                   fileName:string,
                   fileLocation:string,
                   containerName:string,
                   category:string,
                   createdDate:Date,
                   createdBy:number,
                   patId:string,
                   empId:string,
                   phyId:string,
                   tenantId:string,
                   branchId:string,
                   templateId:number,
                   visitId:number,
                   isView:boolean, 
                   isEdit:boolean,
                   isCreate :boolean,
                   parentId:number,
                   childId:number,
                   subHeaderId:number,
                   file:string,
                   deleteFlag:boolean
}

export abstract class ClinicalAssessmentData {
    abstract list<type>(url: string,params?:HttpParams): Observable<type>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getById<type>(url: string,params?:HttpParams): Observable<type>;
    abstract create<type,returnType>(url: string, data:type,params?:HttpParams): Observable<returnType>;
    abstract update(url: string, data: any,params?:HttpParams): Observable<any>;
    abstract updateassessTransaction<type>(url: string, data:type,params:HttpParams): Observable<any>;
    abstract delete(url: string): Observable<any>;
    abstract getassessmentById(url: string,params:HttpParams): Observable<any>;
}
